import { useEffect, useMemo, useState } from 'react';
import subscriptionModalUsers from '../config/subscriptionModalUsers.json';

const DASHBOARD_SUBSCRIPTION_MODAL_SESSION_KEY = 'dashboardSubscriptionModalShown';

export const SUBSCRIPTION_CHECKOUT_URL_100 = 'https://buy.stripe.com/14A4gzfnl2z51Fp7Q8fIs04?client_reference_id=1-';
export const SUBSCRIPTION_CHECKOUT_URL_200 = 'https://buy.stripe.com/dRmdR95ML4Hdesb1rKfIs01?client_reference_id=2-';
export const SUBSCRIPTION_CHECKOUT_URL_500 = 'https://buy.stripe.com/bJeaEX2Az4Hdfwfb2kfIs02?client_reference_id=5-';
export const SUBSCRIPTION_CHECKOUT_URL_800 = 'https://buy.stripe.com/28EbJ1dfdehN6ZJ8UcfIs05?client_reference_id=8-';
export const SUBSCRIPTION_CHECKOUT_URL_201_NO_FREE_TRIAL =
 'https://buy.stripe.com/5kQeVd6QP8Xt3Nx9YgfIs07?client_reference_id=201-';
// export const SUBSCRIPTION_CHECKOUT_URL_11 =  'https://buy.stripe.com/cNi00j4IH5Lh5VF8UcfIs06?client_reference_id=11-';

export const buildSubscriptionCheckoutUrl = (checkoutUrl, storeId) => {
  const normalizedStoreId = storeId ? String(storeId).trim() : '';
  if (!normalizedStoreId) return checkoutUrl;
  const checkoutUrlObj = new URL(checkoutUrl);
  const currentClientReferenceId = checkoutUrlObj.searchParams.get('client_reference_id') || '';
  checkoutUrlObj.searchParams.set(
    'client_reference_id',
    `${currentClientReferenceId}${normalizedStoreId}`
  );
  return checkoutUrlObj.toString();
};

export function useDashboardSubscriptionModal(session, isPaid) {
  const [isSubscriptionModalOpen, setIsSubscriptionModalOpen] = useState(false);

  const isSubscriptionDisabledForUser = useMemo(() => {
    return isPaid;
  }, [isPaid]);

  useEffect(() => {
    // Never open subscription modal before authentication; it can lock body scroll.
    if (!session?.user) {
      setIsSubscriptionModalOpen(false);
      return;
    }

    if (isPaid) {
      setIsSubscriptionModalOpen(false);
    } else {
    setIsSubscriptionModalOpen(true);
    }
  }, [session, isPaid]);

  useEffect(() => {
    if (!isSubscriptionModalOpen) return undefined;
    const handleEscape = (event) => {
      if (event.key === 'Escape') setIsSubscriptionModalOpen(false);
    };
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', handleEscape);
    return () => {
      document.body.style.overflow = originalOverflow;
      window.removeEventListener('keydown', handleEscape);
    };
  }, [isSubscriptionModalOpen]);

  return {
    isSubscriptionModalOpen,
    isSubscriptionDisabledForUser,
    openSubscriptionModal: () => setIsSubscriptionModalOpen(true),
    closeSubscriptionModal: () => setIsSubscriptionModalOpen(false),
  };
}
